import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import { getUserProfile } from '../services/api';

function OnboardedRoute({ component: Component }) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const [checkingProfile, setCheckingProfile] = useState(true);
  const [redirectTo, setRedirectTo] = useState(null);

  useEffect(() => {
    let isActive = true;

    const checkOnboardingStatus = async () => {
      try {
        const data = await getUserProfile();
        const onboarded = data?.company?.onboarded;

        if (!data?.company || !onboarded) {
          if (isActive) setRedirectTo({ path: '/onboarding' });
        }
      } catch (err) {
        const isAuthFailure =
          err?.code === 'AUTH_TOKEN_TIMEOUT' ||
          err?.code === 'AUTH_TOKEN_UNAVAILABLE' ||
          err?.response?.status === 401;

        if (isAuthFailure) {
          loginWithRedirect();
          return;
        }

        if (err.response?.status === 403 && err.response?.data?.error === 'ACCESS_DENIED') {
          if (isActive) {
            setRedirectTo({
              path: '/access-denied',
              state: {
                companyName: err.response.data.companyName,
                message: err.response.data.message
              }
            });
          }
        } else {
          if (isActive) setRedirectTo({ path: '/onboarding' });
        }
      } finally {
        if (isActive) setCheckingProfile(false);
      }
    };

    if (isAuthenticated && !isLoading) {
      checkOnboardingStatus();
    } else if (!isLoading) {
      setCheckingProfile(false);
    }

    return () => {
      isActive = false;
    };
  }, [isAuthenticated, isLoading, loginWithRedirect]);

  if (isLoading || (isAuthenticated && checkingProfile)) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/" />;
  if (redirectTo) return <Navigate to={redirectTo.path} state={redirectTo.state} />;

  return <Component />;
}

export default OnboardedRoute;
